module.exports = __webpack_public_path__ + "img/taketomi_10.d714ca84.jpg";